import { styled } from '@mui/material';
import { ChangeEventHandler } from 'react';
import { VideoType } from '../../utils/video';
import config from '../../config';

const Input = styled('input')({
  display: 'none',
});

type InputVideoHandler = (file: File, type: string) => void;

type InputVideoProps = {
  id: string,
  isDisabled: boolean,
  fileHandler: InputVideoHandler,
  type: VideoType,
  onMaxVideoSizeExceeded?: (message: string) => void
};

function InputVideo({
  id,
  isDisabled,
  fileHandler,
  type,
  onMaxVideoSizeExceeded,
}: InputVideoProps) {
  const handleVideos: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { files } = event.currentTarget;

    if (!files || files?.length === 0) return;

    const file = files[0];
    if (!file.type.includes('video/')) {
      event.currentTarget.value = '';
      return;
    }

    if (file.size > config.video.maxVideoSize) {
      if (onMaxVideoSizeExceeded) {
        onMaxVideoSizeExceeded(`Video file size must be ${config.video.maxVideoSizeInMb}MB or less.`);
      }
      event.currentTarget.value = '';
      return;
    }

    fileHandler(file, type);
    event.currentTarget.value = ''; // TODO: check if there's a better way to do this
  };

  return (
    <Input
      disabled={isDisabled}
      accept="video/mp4,video/webm"
      id={id}
      multiple
      type="file"
      onChange={(e) => { handleVideos(e); }}
    />
  );
}

export default InputVideo;
